

import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { socialMedia } from '../services/userProfile';

const Footer = () => {
    const [social, setSocila] = useState();
    const [openSections, setOpenSections] = useState({});

    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth >= 992);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleSection = (section) => {
        setOpenSections(prev => ({
            ...prev,
            [section]: !prev[section]
        }));
    };

    const getSocial = async () => {
        try {
            const res = await socialMedia();
            setSocila(res.data);
        } catch (error) {
            console.log("error", error.message);
        }
    }

    useEffect(() => {
        getSocial();
    }, []);

    return (
        <>
            <footer className="footer__section bg__black">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="dit">
                                <div className="elementor-icon-box-wrapper d-flex">
                                    <div className="elementor-icon-box-icon">
                                        <span className="elementor-icon">
                                            <i aria-hidden="true" className="fa fa-truck"></i>
                                        </span>
                                    </div>
                                    <div className="elementor-icon-box-content">
                                        <div className="elementor-icon-box-title">
                                            <span style={{ fontSize: '20px', fontWeight: 600, color: '#fff' }}>
                                                Free Shipping
                                            </span>
                                        </div>
                                        <p className="elementor-icon-box-description" style={{ color: '#ffffff' }}>
                                            Free shipping on order over ₹999 via online payments only
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="dit">
                                <div className="elementor-icon-box-wrapper d-flex">
                                    <div className="elementor-icon-box-icon">
                                        <span className="elementor-icon">
                                            <i aria-hidden="true" className="fa fa-share"></i>
                                        </span>
                                    </div>
                                    <div className="elementor-icon-box-content">
                                        <div className="elementor-icon-box-title">
                                            <span style={{ fontSize: '20px', fontWeight: 600, color: '#fff' }}>
                                                Free Return
                                            </span>
                                        </div>
                                        <p className="elementor-icon-box-description" style={{ color: '#ffffff' }}>
                                            Free return in 48 hour after purchasing
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="dit">
                                <div className="elementor-icon-box-wrapper d-flex">
                                    <div className="elementor-icon-box-icon">
                                        <span className="elementor-icon">
                                            <i aria-hidden="true" className="fa fa-shield"></i>
                                        </span>
                                    </div>
                                    <div className="elementor-icon-box-content">
                                        <div className="elementor-icon-box-title">
                                            <span style={{ fontSize: '20px', fontWeight: 600, color: '#fff' }}>
                                                100% Secure
                                            </span>
                                        </div>
                                        <p className="elementor-icon-box-description" style={{ color: '#ffffff' }}>
                                            Secure payments with private security network.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="main__footer d-flex justify-content-between">

                        {/* About Us */}
                        <div className="footer__widget footer__widget--width">
                            <h2 className="footer__widget--title text-ofwhite h3">
                                About Us
                                <button
                                    className="footer__widget--button"
                                    aria-label="footer widget button"
                                    onClick={() => toggleSection('about')}
                                >
                                    <svg
                                        className="footer__widget--title__arrowdown--icon"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12.355"
                                        height="8.394"
                                        viewBox="0 0 10.355 6.394"
                                        style={{
                                            transform: openSections['about'] ? 'rotate(180deg)' : 'rotate(0deg)',
                                            transition: 'transform 0.3s ease'
                                        }}
                                    >
                                        <path d="M15.138,8.59l-3.961,3.952L7.217,8.59,6,9.807l5.178,5.178,5.178-5.178Z" transform="translate(-6 -8.59)" fill="currentColor"></path>
                                    </svg>
                                </button>
                            </h2>
                            <div
                                className="footer__widget--inner"
                               style={{ display: isDesktop || openSections['about'] ? 'block' : 'none' }}
                            >
                                <p className="footer__widget--desc text-ofwhite mb-20">
                                    Overay is India's fastest growing fashion brand with the coolest designs and style of apparel For Men and Women.
                                </p>
                                <div className="footer__social">
                                    <h3 className="social__title text-ofwhite h4 mb-15">Follow Us</h3>
                                    <ul className="social__shear d-flex">
                                        <li className="social__shear--list">
                                            <a className="social__shear--list__icon" href={social?.data?.socialLinks?.facebook} target="_blank" rel="noopener noreferrer">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                                    <path d="M22.675 0H1.325C.593 0 0 .593 0 1.325v21.351C0 23.407.593 24 1.325 24h11.495v-9.294H9.692v-3.622h3.128V8.413c0-3.1 1.894-4.788 4.659-4.788 1.325 0 2.463.099 2.794.143v3.24h-1.918c-1.504 0-1.796.716-1.796 1.765v2.314h3.587l-.467 3.622h-3.12V24h6.116C23.407 24 24 23.407 24 22.676V1.325C24 .593 23.407 0 22.675 0z" />
                                                </svg>
                                                <span className="visually-hidden">Facebook</span>
                                            </a>
                                        </li>
                                        <li className="social__shear--list">
                                            <a className="social__shear--list__icon" href={social?.data?.socialLinks?.twitter} target="_blank" rel="noopener noreferrer">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                                    <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53A4.48 4.48 0 0 0 22.4.36a9.09 9.09 0 0 1-2.88 1.1A4.52 4.52 0 0 0 16.11 0c-2.63 0-4.77 2.13-4.77 4.76 0 .37.04.73.12 1.07A12.9 12.9 0 0 1 3.07.57a4.73 4.73 0 0 0-.64 2.4c0 1.65.85 3.11 2.15 3.97A4.52 4.52 0 0 1 .96 6v.06c0 2.3 1.64 4.22 3.82 4.65a4.44 4.44 0 0 1-2.15.08c.6 1.88 2.34 3.25 4.4 3.29A9.05 9.05 0 0 1 0 19.54a12.8 12.8 0 0 0 6.92 2.03c8.3 0 12.84-6.87 12.84-12.83 0-.2 0-.4-.02-.6A9.22 9.22 0 0 0 23 3z" />
                                                </svg>
                                                <span className="visually-hidden">Twitter</span>
                                            </a>
                                        </li>
                                        <li className="social__shear--list">
                                            <a className="social__shear--list__icon" href={social?.data?.socialLinks?.instagram} target="_blank" rel="noopener noreferrer">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                                    <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2Zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5A4.25 4.25 0 0 0 7.75 20.5h8.5a4.25 4.25 0 0 0 4.25-4.25v-8.5A4.25 4.25 0 0 0 16.25 3.5h-8.5ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 1.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm5.25-.75a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" />
                                                </svg>
                                                <span className="visually-hidden">Instagram</span>
                                            </a>
                                        </li>
                                        <li className="social__shear--list">
                                            <a className="social__shear--list__icon" href={social?.data?.socialLinks?.linkedin} target="_blank" rel="noopener noreferrer">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                                    <path d="M22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.226.792 24 1.771 24h20.451C23.206 24 24 23.226 24 22.271V1.729C24 .774 23.206 0 22.225 0zM7.081 20.452H3.542V9h3.539v11.452zM5.312 7.431a2.046 2.046 0 110-4.093 2.046 2.046 0 010 4.093zM20.452 20.452h-3.539v-5.605c0-1.336-.024-3.056-1.86-3.056-1.86 0-2.145 1.453-2.145 2.954v5.707h-3.538V9h3.398v1.561h.049c.474-.898 1.633-1.84 3.362-1.84 3.594 0 4.258 2.367 4.258 5.448v6.283z" />
                                                </svg>
                                                <span className="visually-hidden">LinkedIn</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {/* For You + Information */}
                        <div className="footer__widget--menu__wrapper d-flex footer__widget--width">

                            {/* For You */}
                            <div className="footer__widget">
                                <h2 className="footer__widget--title text-ofwhite h3">
                                    For You
                                    <button
                                        className="footer__widget--button"
                                        aria-label="footer widget button"
                                        onClick={() => toggleSection('forYou')}
                                    >
                                        <svg
                                            className="footer__widget--title__arrowdown--icon"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="12.355"
                                            height="8.394"
                                            viewBox="0 0 10.355 6.394"
                                            style={{
                                                transform: openSections['forYou'] ? 'rotate(180deg)' : 'rotate(0deg)',
                                                transition: 'transform 0.3s ease'
                                            }}
                                        >
                                            <path d="M15.138,8.59l-3.961,3.952L7.217,8.59,6,9.807l5.178,5.178,5.178-5.178Z" transform="translate(-6 -8.59)" fill="currentColor"></path>
                                        </svg>
                                    </button>
                                </h2>
                                <ul
                                    className="footer__widget--menu footer__widget--inner"
                                   style={{ display: isDesktop || openSections['forYou'] ? 'block' : 'none' }}
                                >
                                    <li className="footer__widget--menu__list">
                                        <Link className="footer__widget--menu__text" to="/my-Profile">My Account</Link>
                                    </li>
                                </ul>
                            </div>

                            {/* Information */}
                            <div className="footer__widget">
                                <h2 className="footer__widget--title text-ofwhite h3">
                                    Information
                                    <button
                                        className="footer__widget--button"
                                        aria-label="footer widget button"
                                        onClick={() => toggleSection('information')}
                                    >
                                        <svg
                                            className="footer__widget--title__arrowdown--icon"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="12.355"
                                            height="8.394"
                                            viewBox="0 0 10.355 6.394"
                                            style={{
                                                transform: openSections['information'] ? 'rotate(180deg)' : 'rotate(0deg)',
                                                transition: 'transform 0.3s ease'
                                            }}
                                        >
                                            <path d="M15.138,8.59l-3.961,3.952L7.217,8.59,6,9.807l5.178,5.178,5.178-5.178Z" transform="translate(-6 -8.59)" fill="currentColor"></path>
                                        </svg>
                                    </button>
                                </h2>
                                <ul
                                    className="footer__widget--menu footer__widget--inner"
                                    style={{ display: isDesktop || openSections['information'] ? 'block' : 'none' }}
                                >
                                    <li className="footer__widget--menu__list"><Link className="footer__widget--menu__text" to="/about-us">About Us</Link></li>
                                    <li className="footer__widget--menu__list"><Link className="footer__widget--menu__text" to="/my-orders">Track My Order</Link></li>
                                    <li className="footer__widget--menu__list"><Link className="footer__widget--menu__text" to="/privacy-Policy">Privacy Policy</Link></li>
                                    <li className="footer__widget--menu__list"><Link className="footer__widget--menu__text" to="/terms-condition">Terms & Condition</Link></li>
                                    <li className="footer__widget--menu__list"><Link className="footer__widget--menu__text" to="/contact-us">Contact Us</Link></li>
                                    <li className="footer__widget--menu__list"><Link className="footer__widget--menu__text" to="/shiping-delivery">Shiping & Delivery</Link></li>
                                    <li className="footer__widget--menu__list"><Link className="footer__widget--menu__text" to="/cancellation-refund">Cancellation & Refund</Link></li>
                                    <li className="footer__widget--menu__list"><Link className="footer__widget--menu__text" to="/faqs">Faqs</Link></li>
                                </ul>
                            </div>
                        </div>

                        {/* Contact Info */}
                        <div className="footer__widget footer__widget--width">
                            <h2 className="footer__widget--title text-ofwhite h3">
                                Contact Info
                                <button
                                    className="footer__widget--button"
                                    aria-label="footer widget button"
                                    onClick={() => toggleSection('contact')}
                                >
                                    <svg
                                        className="footer__widget--title__arrowdown--icon"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="12.355"
                                        height="8.394"
                                        viewBox="0 0 10.355 6.394"
                                        style={{
                                            transform: openSections['contact'] ? 'rotate(180deg)' : 'rotate(0deg)',
                                            transition: 'transform 0.3s ease'
                                        }}
                                    >
                                        <path d="M15.138,8.59l-3.961,3.952L7.217,8.59,6,9.807l5.178,5.178,5.178-5.178Z" transform="translate(-6 -8.59)" fill="currentColor"></path>
                                    </svg>
                                </button>
                            </h2>
                            <div
                                className="footer__instagram footer__widget--inner space-y-2"
                              style={{ display: isDesktop || openSections['contact'] ? 'block' : 'none' }}
                            >
                                <p className="text-white">{social?.data?.address}</p>
                                <p className="text-white">
                                    <strong>Call Us:</strong> {social?.data?.phone}
                                </p>
                                <p className="text-white">
                                    <strong>Email:</strong> {social?.data?.email}
                                </p>
                            </div>
                        </div>

                    </div>

                    <div className="footer__bottom d-flex justify-content-between align-items-center">
                        <p className="copyright__content text-ofwhite m-0">Copyright © 2025 Overay . All Rights Reserved.</p>
                        <div className="footer__payment text-right">
                            <img className="display-block" src="/assets/img/other/payment-visa-card.png" alt="visa-card" />
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer